<fgb-banner [pageTitle]="title" />

<fgb-page-header [pageTitle]="'account.nav.profile'" [showBalance]="true"></fgb-page-header>

<div class="account-layout-padding mobile-content-wrapper">
  <div class="container">
    <fgb-route-nav indicatorStyle="rounded" (onTabChange)="title = $event">
      <a class="nav-item" [routerLink]="['/account']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
        <label>{{ 'account.nav.profile' | translate }}</label>
        <div class="nav-item-bg"></div>
      </a>
      <a
        class="nav-item"
        [routerLink]="['/account/activity']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'account.nav.activity' | translate }}</label>
        <div class="nav-item-bg"></div>
      </a>
    </fgb-route-nav>
  </div>
</div>

<router-outlet></router-outlet>
